import React from 'react';

const UncheckedLabel = () => {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Unchecked</title>
      <desc>Created with Sketch.</desc>
      <g id="Filter" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Fibre/Desktop/planselectio-Copy-6" transform="translate(-315.000000, -482.000000)" fill="#FFFFFF" stroke="#999999">
          <g id="🧩-Components/Forms:-Selection/Checkbox/Colour/Unchecked" transform="translate(315.000000, 482.000000)">
            <rect id="Rectangle-5" x="0.5" y="0.5" width="19" height="19" rx="2"></rect>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default UncheckedLabel;